module.exports = __webpack_public_path__ + "img/1161435554.c6757cff.jpg";